





































































































































































import {Component, Prop, Provide, Vue, Watch} from 'vue-property-decorator';
import {GridItem, GridLayout} from 'vue-grid-layout';
import SelectionList from '@c/controls/selectionList/SelectionList.vue';
import {SensorCard, WidgetCard} from '@/views/dashboard/interfaces';
import {SensorType} from '@v/dashboard/enums';
import {getWidgetTemplates} from './configurate';
import Sensor from '@/components/Sensor.vue';
import Widget from '@/components/Widget.vue';
import {uuidv4} from '@/utils/uuidUtils';
import {
  forbiddenSensorValueInfoesMap,
  SensorDeskColumns,
  SensorDeskLayoutWidth,
  sensorTypeComponentMap,
  widgetComponentBindingMap,
} from '@/views/dashboard/sensorDesk/configurate';
import {
  SelectionListFilterModel,
  SelectionListGroupingModel,
} from '@/components/controls/selectionList/interfaces';
import SimpleDialog from '@c/SimpleDialog.vue';
import userSettingsStoreModule from '@/store/modules/userSettingsModule';
import Loading from '@c/controls/Loading.vue';
import {PModuleMeasurement, PModuleWithMeasurements} from '@/views/system/modules/interfaces';
import {pmoduleTypeFilter} from '@/components/nodeComponent/filters';
import {pmoduleGroupings} from '@/components/nodeComponent/groupings';
import {MeasurementData} from '@/views/system/measurements/interfaces';
import {
  getAllModules,
  getModulesByGuids,
} from '@/store/modules/entities/pmodules/pmoduleWithMeasurementsModule';
import {PModuleType} from '@/enums/configs';
import {getMeasurementById} from '@/utils/moduleUtils';
import {MeasurementType} from '@/views/system/measurements/enums';

@Component({
  components: {
    GridLayout,
    GridItem,
    SelectionList,
    Sensor,
    Widget,
    SimpleDialog,
    Loading,
  },
  inject: [],
})
export default class SensorDesk extends Vue {
  @Provide()
  @Prop()
  measurements!: MeasurementData[];

  @Prop()
  paneSize!: number;

  sensorKey = 0;

  //Кол-во ед. высоты в одной строке
  hPerRow = 1;

  //Максимальное кол-во строк в draggable компоненте
  maxRowNum = this.hPerRow * 50;

  //Высота одной строки draggable компоненты в px
  rowHeight = 20;

  //Список карточек draggable компоненты
  layout: (SensorCard | WidgetCard)[] = [];

  showSelectedPM = false;

  sensorDeskWidth = 0;

  @Watch('measurements')
  onMeasurementLoaded() {
    this.sensorKey++;
  }

  //Загрузка шаблонов виджетов (TODO: из моковых данных)
  widgetTemplates = getWidgetTemplates();

  //Модель диалога выбора шаблонов виджетов
  addWidgetTemplateDialog = false;

  //Список выбираемых в диалоговом окне индентификаторов шаблонов виджетов
  dialogSelectedWidgetTemplateIds: string[] = [];

  // Фильтр программных модулей по типу
  pmoduleTypeFilter: SelectionListFilterModel = pmoduleTypeFilter;

  // Список группировок программных модулей
  pmoduleGroupings: SelectionListGroupingModel[] = pmoduleGroupings;

  //Размеры экрана для установки количества колонок в layout
  ssdWidth = SensorDeskLayoutWidth.Ssd;
  sdWidth = SensorDeskLayoutWidth.Sd;
  mdWidth = SensorDeskLayoutWidth.Md;
  ldWidth = SensorDeskLayoutWidth.Ld;

  //Кол-ва колонок в layout
  ldLayoutCols = SensorDeskColumns.Ld;
  mdLayoutCols = SensorDeskColumns.Md;
  sdLayoutCols = SensorDeskColumns.Sd;
  ssdLayoutCols = SensorDeskColumns.Ssd;
  sssdLayoutCols = SensorDeskColumns.Sssd;

  //Модель кнопки редактирования
  editButton = false;

  //Показатель режима редактирования
  edit = false;

  //Показатели загрузки и ошибки загрузки датчиков
  sensorsLoading = false;
  sensorsError = false;

  //Список выбранных компонент
  selectedComponentIds: string[] = [];
  dialogSelectedComponentIds: string[] = [];

  //Список программных модулей
  pmodules: PModuleWithMeasurements[] = [];

  selectedPModuleGuids: string[] = [];
  dialogSelectedPModuleIds: string[] = [];

  //Справочников типов: датчик или виджет
  sensorType = SensorType;

  //Модель для окна добавления датчиков по программным модулям
  addPModulesDialog = false;

  @Watch('addPModulesDialog')
  onAddConfigsDialog(value: boolean) {
    if (value) {
      this.dialogSelectedPModuleIds = [...this.selectedPModuleGuids];
      this.dialogSelectedComponentIds = [...this.selectedComponentIds];
    }
  }

  //Количество колонок в draggable компоненте
  get colNum() {
    if (this.sensorDeskWidth >= this.ldWidth) {
      return this.ldLayoutCols;
    } else if (this.sensorDeskWidth >= this.mdWidth && this.sensorDeskWidth < this.ldWidth) {
      return this.mdLayoutCols;
    } else if (this.sensorDeskWidth >= this.sdWidth && this.sensorDeskWidth < this.mdWidth) {
      return this.sdLayoutCols;
    } else if (this.sensorDeskWidth >= this.ssdWidth && this.sensorDeskWidth < this.sdWidth) {
      return this.ssdLayoutCols;
    } else {
      return this.sssdLayoutCols;
    }
  }

  paneSizeChanged(value: any) {
    if (value) this.sensorDeskWidth = value;
    else this.sensorDeskWidth = (this.$refs.sensorDesk as any).offsetWidth;
  }

  changePMList(value: any) {
    this.showSelectedPM = value;
  }

  //Получаем список датчиков и виджетов, у которых на данный момент есть координаты для текущей сетки.
  getCardsHaveCoords(cards: any[]) {
    const cardsHaveCoords = cards.filter(
      (card: any) =>
        (this.colNum === this.sdLayoutCols && card.xs !== undefined) ||
        (this.colNum === this.mdLayoutCols && card.xm !== undefined) ||
        (this.colNum === this.ldLayoutCols && card.xl !== undefined) ||
        (this.colNum === this.ssdLayoutCols && card.xss !== undefined),
    );

    cardsHaveCoords.forEach(c => {
      switch (this.colNum) {
        case SensorDeskColumns.Ld:
          c.x = c.xl;
          c.y = c.yl;
          break;
        case SensorDeskColumns.Md:
          c.x = c.xm;
          c.y = c.ym;
          break;
        case SensorDeskColumns.Sd:
          c.x = c.xs;
          c.y = c.ys;
          break;
        case SensorDeskColumns.Ssd:
          c.x = c.xss;
          c.y = c.yss;
          break;
      }
    });

    return cardsHaveCoords;
  }

  // Копируем координаты карточки из меньшей сетки в большую, если они есть.
  copyCardsCoords(cards: any[]) {
    const cardsHaveCoords = cards.filter(
      (card: any) =>
        (this.colNum === this.ssdLayoutCols && card.xss !== undefined) ||
        (this.colNum === this.sdLayoutCols && (card.xs !== undefined || card.xss !== undefined)) ||
        (this.colNum === this.mdLayoutCols &&
          (card.xm !== undefined || card.xs !== undefined || card.xss !== undefined)) ||
        (this.colNum === this.ldLayoutCols &&
          (card.xl !== undefined ||
            card.xm !== undefined ||
            card.xs !== undefined ||
            card.xss !== undefined)),
    );

    cardsHaveCoords.forEach(async (c: any) => {
      switch (this.colNum) {
        case SensorDeskColumns.Ld:
          c.x = c.xl = c.xm ?? c.xs ?? c.xss;
          c.y = c.yl = c.ym ?? c.ys ?? c.yss;
          break;
        case SensorDeskColumns.Md:
          c.x = c.xm = c.xs ?? c.xss;
          c.y = c.ym = c.ys ?? c.yss;
          break;
        case SensorDeskColumns.Sd:
          c.x = c.xs = c.xss;
          c.y = c.ys = c.yss;
          break;
      }
      userSettingsStoreModule.updateCardCoordinates(c);

      // сохраняем настройки из localStorage в БД
      await userSettingsStoreModule.saveLocalSettingsToDB();
    });

    return cardsHaveCoords;
  }

  //при изменении количества столбцов в layout размещаем все карточки заново
  @Watch('colNum')
  onColNumChanged(newVal: number, oldVal: number) {
    let cardsHaveCoords = this.getCardsHaveCoords(this.layout);

    // ни одна карточка не имеет координат в текущей сетке, поэтому можем попробовать на большей сетке сохранить меньшую
    if (newVal > oldVal && this.layout.length && !cardsHaveCoords.length) {
      cardsHaveCoords = this.copyCardsCoords(this.layout);
    }

    const cardsDoesntHaveCoords = this.layout.filter(
      (card: any) => !cardsHaveCoords.includes(card),
    );
    this.layout = cardsHaveCoords.concat(
      this.getPlacedCards(cardsHaveCoords, cardsDoesntHaveCoords),
    );
  }

  //Переменная для обновления грида с виджетами, когда вручную меняем высоту элемента
  gridKey = 0;

  //если во время конфигурации шаблона виджета происходит изменение его размеров, то обновляем грид с виджетами
  updateGrid() {
    this.gridKey++;
  }

  //Алгоритм размещения карточек
  //первый параметр - layout на который добавляем карточки
  //второй - добавляемые карточки
  getPlacedCards(currentLayout: any[], cards: any[]): any[] {
    const placedCards: any[] = [];
    cards.forEach(c => {
      for (let y = 0; y <= this.maxRowNum; y += this.hPerRow) {
        let find = false;
        for (let x = 0; x + c.w <= this.colNum; ++x) {
          if (!currentLayout.concat(placedCards).some(z => this.isIntersect(x, y, c.w, c.h, z))) {
            c.x = x;
            c.y = y;
            placedCards.push(c);
            this.setItemCoordinates(c);
            find = true;
            break;
          }
        }
        if (find) {
          break;
        }
      }
    });
    return placedCards;
  }

  // Действия при преобразовании шаблона виджета в виджет
  async onSaveWidgetTemplate(widgetTemplate: any, widget: any) {
    const copiedLayout = [...this.layout];
    for (let i = 0; i < copiedLayout.length; ++i) {
      if (copiedLayout[i] == widgetTemplate) {
        //загружаем виджет
        copiedLayout[i] = widget;
        copiedLayout[i].i = widget.id;
      }
    }

    // сохраняем настройки из localStorage в БД
    await userSettingsStoreModule.saveLocalSettingsToDB();

    // TODO: изучить возможно ли сделать обновление без перерисовки всех виджетов
    this.layout = [...copiedLayout];
  }

  // Проверка пересечения карточек
  isIntersect(x: number, y: number, w: number, h: number, c: SensorCard) {
    const firstRect = {x: c.x, y: c.y, w: c.w, h: c.h};
    const secondRect = {x: x, y: y, w: w, h: h};
    return this.rectIntersect(
      {x: firstRect.x, y: firstRect.y},
      {x: firstRect.x + firstRect.w - 1, y: firstRect.y + firstRect.h - 1},
      {x: secondRect.x, y: secondRect.y},
      {x: secondRect.x + secondRect.w - 1, y: secondRect.y + secondRect.h - 1},
    );
  }

  rectIntersect(
    l1: {x: number; y: number},
    r1: {x: number; y: number},
    l2: {x: number; y: number},
    r2: {x: number; y: number},
  ) {
    return l1.x <= r2.x && r1.x >= l2.x && l1.y <= r2.y && r1.y >= l2.y;
  }

  // Действия при добавлении шаблонов виджетов (Шаблоны всегда добавляются)
  async onSelectWidgetTemplate() {
    const addedWidgetTemplates: any[] = [];

    this.dialogSelectedWidgetTemplateIds.forEach(id => {
      const card = this.widgetTemplates.find(x => x.templateId === id);
      if (card) addedWidgetTemplates.push({...card});
    });

    addedWidgetTemplates.forEach(c => {
      c.i = uuidv4();
      c.component = widgetComponentBindingMap.get(c.componentName);
    });

    const addedLayout = this.getPlacedCards(this.layout, addedWidgetTemplates);

    this.layout = this.layout.concat(addedLayout);
    this.dialogSelectedWidgetTemplateIds = [];
  }

  // Действия при выборе программных модулей для создания по ним датчиков на дашборде
  async onSelectPModules() {
    this.selectedPModuleGuids = [...this.dialogSelectedPModuleIds];
    //по выбранным идентификаторам датчиков загружаем все измерения и на их основе добавляем карточки
    try {
      this.pmodulesLoading = true;
      this.pmodulesError = false;

      const guids = this.selectedPModules.map(c => c.guid as string);

      const sensorList: SensorCard[] = [];
      const dataModules = await getModulesByGuids(guids);

      dataModules.forEach((pmodule: PModuleWithMeasurements) => {
        const moduleGUID = pmodule?.guid as string;
        const moduleId = pmodule?.id as number;
        const moduleType = pmodule?.type as PModuleType;
        const moduleName = pmodule?.name as string;
        const moduleAlias = pmodule?.alias as string;

        pmodule.measurements.forEach((x: PModuleMeasurement) => {
          if (!x.measurementId) return;

          const measurement = getMeasurementById(this.measurements, x.measurementId);
          if (!measurement || measurement.type !== MeasurementType.Signal) return;

          const key = uuidv4();
          sensorList.push({
            x: 0,
            y: 0,
            w: 2,
            h: 4 * this.hPerRow,
            isResizable: false,
            templateId: key,
            pmoduleId: moduleId,
            id: key,
            i: key,
            static: false,
            name: `${moduleName} ${measurement.name}`,
            type: SensorType.Sensor,
            component: sensorTypeComponentMap.get(moduleType),
            moduleGUID: moduleGUID,
            moduleAlias: moduleAlias,
            moduleType: moduleType,
            measurement: measurement,
          });
        });
      });
      //добавляемые датчики
      const addedSensors = sensorList.filter(
        x =>
          !this.layout.some(y => x.name === y.name) &&
          !forbiddenSensorValueInfoesMap
            .get(x?.moduleType as PModuleType)
            ?.includes(x.measurement?.alias as string),
      );

      //удаляемые датчики
      const removedSensors = this.layout.filter(
        x => x.type === SensorType.Sensor && !sensorList.some(y => x.name === y.name),
      );

      //размещаем все добавленные карточки на layout
      const addedLayout = this.getPlacedCards(this.layout, addedSensors);

      //убираем датчики из настроек дашборда пользователя
      userSettingsStoreModule.removeCards(removedSensors);

      // сохраняем настройки из localStorage в БД
      await userSettingsStoreModule.saveLocalSettingsToDB();

      //обновляем layout
      this.layout = this.layout.filter(x => !removedSensors.includes(x)).concat(addedLayout);
    } catch {
      this.pmodulesError = true;
    } finally {
      this.pmodulesLoading = false;
    }
  }

  // Действия при удалении карточки по кнопке
  async removeCard(card: any) {
    const index = this.layout.map(item => item.i).indexOf(card.i);
    this.layout.splice(index, 1);
    this.selectedPModuleGuids = [
      ...new Set(
        (this.layout.filter(item => item.type === SensorType.Sensor) as SensorCard[]).map(
          (item: SensorCard) => item.moduleGUID,
        ),
      ),
    ];

    //убираем датчик/виджет из настроек дашборда пользователя
    userSettingsStoreModule.removeCards([card]);

    // сохраняем настройки из localStorage в БД
    await userSettingsStoreModule.saveLocalSettingsToDB();
  }

  // Цвет кнопки редактирования
  get editButtonColor() {
    return this.edit ? 'red' : 'blue';
  }

  // Выбранные программные модули
  get selectedPModules() {
    return this.pmodules.filter((x: any) => this.selectedPModuleGuids.includes(x.guid));
  }

  // Загрузка программных модулей
  pmodulesLoading = true;
  pmodulesError = false;
  async loadPModules() {
    try {
      this.pmodulesLoading = true;
      this.pmodulesError = false;
      const pmodules = await getAllModules(); //TODO: refactor, use store
      this.pmodules = pmodules.filter(
        x =>
          x.measurements &&
          x.type !== PModuleType.BearingControlModule &&
          x.type !== PModuleType.HeaterMonitorModule &&
          x.type !== PModuleType.DtcpServerModule,
      );
    } catch (error) {
      console.error(error);
      this.pmodulesError = true;
    } finally {
      this.pmodulesLoading = false;
    }
  }

  async created() {
    //Получаем список всех программных модулей - датчиков
    await this.loadPModules();
  }

  async mounted() {
    this.sensorDeskWidth = (this.$refs.sensorDesk as any).offsetWidth;
    const pmodules = await getAllModules();
    const cards = (await userSettingsStoreModule.getCards()) || [];
    const guidsSet = new Set<string>();
    cards.forEach((card: any) => {
      if (card.type == this.sensorType.Sensor) {
        const pmodule = pmodules.find(x => x.id == card.pmoduleId && x.type == card.moduleType);
        card.w = 2;
        card.h = 4 * this.hPerRow;
        card.isResizable = false;
        card.templateId = card.id;
        card.i = card.id;
        card.static = false;
        card.name = `${pmodule?.name as string} ${card.measurement?.name}`;
        card.type = SensorType.Sensor;
        card.component = sensorTypeComponentMap.get(pmodule?.type as PModuleType);
        card.moduleGUID = pmodule?.guid as string;
        card.moduleAlias = pmodule?.alias as string;
        // moduleGUIDs должны быть уникальны в selectedPModuleGuids.
        // Несколько какрт могут иметь id одного модуля
        guidsSet.add(card.moduleGUID);
      } else if (card.type == this.sensorType.Component) {
        const template = this.widgetTemplates.find(x => x.templateId === card.templateId);
        card.component = widgetComponentBindingMap.get(card.componentName);
        card.name = card.settings?.name;
        card.templateId = template?.templateId;
        card.w = template?.w;
        card.h = template?.h;
        card.static = template?.static;
        card.shortName = template?.shortName;
        card.type = SensorType.Component;
        card.isResizable = template?.isResizable;
        card.i = card.id;
      } else {
        console.error('Unknown type: ' + card.type);
      }
      this.selectedPModuleGuids = [...guidsSet];
    });

    let cardsHaveCoords = this.getCardsHaveCoords(cards);

    // ни одна карточка не имеет координат в текущей сетке, поэтому можем на большей сетке сохранить меньшую
    if (cards.length && !cardsHaveCoords.length) {
      cardsHaveCoords = this.copyCardsCoords(cards);
    }

    const cardsDoesntHaveCoords = cards.filter((card: any) => !cardsHaveCoords.includes(card));
    const newCards = this.getPlacedCards(cardsHaveCoords, cardsDoesntHaveCoords);
    this.layout = cardsHaveCoords.concat(newCards);
  }

  //Сохраняем координаты виджета/датчика для текущей сетки
  setItemCoordinates(item: any) {
    // если это шаблон виджета, то не сохраняем координаты
    if (item.type === this.sensorType.Component && !item.settings) return;

    switch (this.colNum) {
      case SensorDeskColumns.Ld:
        item.xl = item.x;
        item.yl = item.y;
        break;
      case SensorDeskColumns.Md:
        item.xm = item.x;
        item.ym = item.y;
        break;
      case SensorDeskColumns.Sd:
        item.xs = item.x;
        item.ys = item.y;
        break;
      case SensorDeskColumns.Ssd:
        item.xss = item.x;
        item.yss = item.y;
        break;
    }
    userSettingsStoreModule.updateCardCoordinates(item);
  }

  /* Данное событие срабатывает только на элементе, который мы перемещаем. На элементах, которые пассивно перемещаются из-за перемещаемого элемента, данное событие не происходит, поэтому надо сохранять координаты всех элементов*/
  async movedEvent() {
    await Promise.all(this.layout.map((card: any) => this.setItemCoordinates(card)));
    await userSettingsStoreModule.saveLocalSettingsToDB();
  }
}
